import {
  Divider,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { formatTimeStampToDate } from 'hooks/date/formattedTime'
import { useTranslation } from 'react-i18next'
import {
  ETenderPaymentSummaryStatus,
  ITendersControlPanelSummary,
} from 'types/tender'

const StyledTable = styled(Table)(() => ({
  borderCollapse: 'collapse',
  width: '100%',
  '& th, & td': {
    border: '1px solid #dddddd !important',
  },
  '& th': {
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  '& .MuiTableCell-root': {
    paddingLeft: '12px',
    paddingRight: '12px',
  },
}))

type Props = {
  controlPanelSummary: ITendersControlPanelSummary
}

export const DocsSubmissionSummaryTable = ({ controlPanelSummary }: Props) => {
  const { t } = useTranslation()
  return (
    <>
      <Divider flexItem />
      <Typography variant="h6">{t('supplier-required-docs')}</Typography>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer>
          <StyledTable
            size="small"
            sx={{ minWidth: 650, borderCollapse: 'collapse' }}
          >
            <TableHead>
              <TableRow>
                <TableCell>{t('supplier-name')}</TableCell>
                <TableCell>{t('submission-presentation-date')}</TableCell>
                <TableCell>{t('date')}</TableCell>
                <TableCell>{t('status')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {controlPanelSummary.submissionSummary.documentSubmissions.map(
                (doc, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell scope="row">{doc.organizationName}</TableCell>
                    <TableCell scope="row">
                      {doc.documentSubmissionDate
                        ? formatTimeStampToDate(doc.documentSubmissionDate)
                        : '-'}
                    </TableCell>
                    <TableCell scope="row">
                      {doc.submissionDate
                        ? formatTimeStampToDate(doc.submissionDate)
                        : '-'}
                    </TableCell>
                    <TableCell scope="row">
                      {doc.submitted
                        ? t('docs-submitted')
                        : t('docs-not-submitted')}
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </Paper>
    </>
  )
}
